module.exports = __webpack_public_path__ + "static/media/triangle.7b84db3f.svg";